import { FC } from 'react';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { createUseStyles } from 'react-jss';
import { dictionary } from '../../../dictionary';
import { Modal } from '../../../Shared/modals/Modal/Modal';
import { Button } from '../../../Shared/buttons/Button';

interface ManuallyDeleteReqModalProps {
  cancelOnClick: () => void;
  isModalOpen: boolean;
  manuallyDeleteReq: (id: number) => void;
  reqId: number | undefined;
}

export const ManuallyDeleteReqModal: FC<ManuallyDeleteReqModalProps> = ({
  cancelOnClick,
  isModalOpen,
  manuallyDeleteReq,
  reqId }) => {
  const ManuallyDeleteReqModalStyles = createUseStyles({
    message: {
      borderBottom: '0.09rem solid #d8d8d8',
      paddingBottom: '1rem',
    },
  });

  const classes = ManuallyDeleteReqModalStyles();

  return (
    <>
      <Modal
        data-testid="update-information-modal"
        title="Delete Requisition"
        isOpen={isModalOpen}
        icon={faInfoCircle}
        actionsContent={(
          <>
            <Button buttonStyle="reverse" onClick={cancelOnClick} data-testid="modal-cancel">
              {dictionary.CANCEL}
            </Button>
            <Button buttonStyle="primary" onClick={() => manuallyDeleteReq(reqId!)} data-testid="modal-continue">
              {dictionary.MANUALLY_DELETE_REQ_CONFIRMATION}
            </Button>
          </>
        )}
      >
        <h3 className={classes.message}>
          { dictionary.MANUALLY_DELETE_REQ_MODAL_QUESTION }
        </h3>
      </Modal>
    </>
  );
};
